export const langCodeAllowed = {
    IN: {
      defaultLocale: 'en_IN',
      localeList: [
        {
          title: 'English',
          code: 'en_IN',
        },
        {
          title: 'Hindi',
          code: 'hi_IN',
        },
      ]
    }
  };
